var render, staticRenderFns
import script from "./FileBarChart.vue?vue&type=script&lang=js&"
export * from "./FileBarChart.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "61e80a0c",
  null
  
)

export default component.exports